import React, { useEffect, useState } from "react";
import axiosInstance from "../../config/axiosInterceptor";

const KycList = ({ forType = "agency" }) => {
  const [kycs, setKycs] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState(""); // new for status filter
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [total, setTotal] = useState(0);
  const [selected, setSelected] = useState([]);
  const [viewKyc, setViewKyc] = useState(null);

  // Only fetch when "Go" is clicked
  const [fetchTrigger, setFetchTrigger] = useState(0);

  const fetchKycs = async () => {
    const params = { search, page, limit, forType };
    if (status) params.status = status;
    const res = await axiosInstance.get(
      `${process.env.REACT_APP_BASEURL1}/admin/kyc/getAllAgencyKyc`,
      { params }
    );
    if (res.data.success) {
      setKycs(res.data.details);
      setTotal(res.data.total);
    }
  };

  useEffect(() => {
    fetchKycs();
    // eslint-disable-next-line
  }, [fetchTrigger, page, limit, forType]);

  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selected.length === kycs.length) setSelected([]);
    else setSelected(kycs.map((k) => k._id));
  };

  const handleApprove = async (ids) => {
    await axiosInstance.post(`${process.env.REACT_APP_BASEURL1}/admin/kyc/approve`, { ids, forType });
    setSelected([]);
    setFetchTrigger(f => f + 1);
  };
  const handleReject = async (ids) => {
    await axiosInstance.post(`${process.env.REACT_APP_BASEURL1}/admin/kyc/reject`, { ids, forType });
    setSelected([]);
    setFetchTrigger(f => f + 1);
  };

  const handleGo = () => {
    setPage(1);
    setFetchTrigger(f => f + 1);
  };

  return (
    <div style={{ maxWidth: 1100, margin: "40px auto", background: "#fff", borderRadius: 12, boxShadow: "0 4px 24px #0002", padding: 24 }}>
      <h2 style={{ textAlign: "center", marginBottom: 18 }}>{forType.toUpperCase()} KYC Approvals</h2>
      <div style={{ display: "flex", gap: 12, marginBottom: 16, alignItems: "center" }}>
        <input
          type="text"
          placeholder="Search by agency name or code"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ padding: 8, borderRadius: 6, border: "1px solid #ccc", width: 220 }}
        />
        <select
          value={status}
          onChange={e => setStatus(e.target.value)}
          style={{ padding: 8, borderRadius: 6, border: "1px solid #ccc", width: 140 }}
        >
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>
        <button
          onClick={handleGo}
          style={{ background: "#1677ff", color: "#fff", border: "none", borderRadius: 6, padding: "8px 24px", fontWeight: 600, cursor: "pointer" }}
        >
          Go
        </button>
        <button
          onClick={() => handleApprove(selected)}
          disabled={selected.length === 0}
          style={{ background: "#52c41a", color: "#fff", border: "none", borderRadius: 6, padding: "8px 24px", fontWeight: 600, cursor: selected.length === 0 ? "not-allowed" : "pointer" }}
        >
          Approve Selected
        </button>
        <button
          onClick={() => handleReject(selected)}
          disabled={selected.length === 0}
          style={{ background: "#faad14", color: "#fff", border: "none", borderRadius: 6, padding: "8px 24px", fontWeight: 600, cursor: selected.length === 0 ? "not-allowed" : "pointer" }}
        >
          Reject Selected
        </button>
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 16 }}>
        <thead>
          <tr style={{ background: "#f5f5f5" }}>
            <th><input type="checkbox" checked={selected.length === kycs.length && kycs.length > 0} onChange={handleSelectAll} /></th>
            <th>Agency Name</th>
            <th>Agency Code</th>
            <th>Created At</th>
            <th>Cashfree Approved</th>
            <th>Admin Approved</th>
            <th>View</th>
          </tr>
        </thead>
        <tbody>
          {kycs.map((k, idx) => (
            <tr key={k._id} style={{ background: idx % 2 === 0 ? "#fafcff" : "#f6f9fc" }}>
              <td><input type="checkbox" checked={selected.includes(k._id)} onChange={() => handleSelect(k._id)} /></td>
              <td>{k.name}</td>
              <td>{k.uniqueId}</td>
              <td>{k.createdAt ? new Date(k.createdAt).toLocaleString() : "-"}</td>
              <td style={{ color: k.verified === true ? "#52c41a" : "#faad14", fontWeight: 600 }}>{k.verified.toLocaleString()}</td>
              <td style={{ color: k.approved === "approved" ? "#52c41a" : k.approved === "rejected" ? "#ff4d4f" : "#faad14", fontWeight: 600 }}>{k.approved}</td>
              <td>
                <button style={{ background: "#1677ff", color: "#fff", border: "none", borderRadius: 5, padding: "6px 16px", cursor: "pointer" }} onClick={() => setViewKyc(k)}>
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>
          Page {page} of {Math.ceil(total / limit) || 1}
        </span>
        <div>
          <button disabled={page === 1} onClick={() => setPage(page - 1)} style={{ marginRight: 8 }}>Prev</button>
          <button disabled={page * limit >= total} onClick={() => setPage(page + 1)}>Next</button>
        </div>
        <span>
          Total Entries: <b>{total}</b>
        </span>
      </div>
      {/* Modal for KYC details */}
      {viewKyc && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.3)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center"
        }}>
          <div style={{
            background: "#fff", borderRadius: 10, boxShadow: "0 4px 24px #0002", minWidth: 400, maxWidth: 600, maxHeight: "90vh", overflowY: "auto", position: "relative", padding: 24
          }}>
            <h3 style={{ marginBottom: 12 }}>Agency KYC Details</h3>
            <div><b>Name:</b> {viewKyc?.cashfreeResponse?.name}</div>
            <div><b>Email:</b> {viewKyc?.cashfreeResponse?.email}</div>
            <div><b>Bank Account Number:</b> {viewKyc?.bankAccountNumber}</div>
            <div><b>Bank IFSC:</b> {viewKyc?.bankAccountIFSC}</div>
            <div><b>Bank Account Holder Name:</b> {viewKyc?.bankAccountHolderName}</div>
            <div><b>Bank Name:</b> {viewKyc?.bankName}</div>
            <div><b>Care of:</b> {viewKyc?.cashfreeResponse?.care_of}</div>
            <div><b>Agency Name:</b> {viewKyc.name}</div>
            <div><b>Agency Code:</b> {viewKyc.uniqueId}</div>
            <div><b>Aadhaar Number:</b> {viewKyc?.aadhaarNumber}</div>
            <div><b>PAN Number:</b> {viewKyc.panNumber}</div>
            <div><b>DOB:</b> {viewKyc?.cashfreeResponse?.dob}</div>
            <div><b>Gender:</b> {viewKyc?.cashfreeResponse?.gender}</div>
            <div><b>Address:</b> {viewKyc?.cashfreeResponse?.address}</div>
            <div><b>District:</b> {viewKyc?.cashfreeResponse?.split_address?.dist}</div>
            <div><b>Sub-District:</b> {viewKyc?.cashfreeResponse?.split_address?.subdist}</div>
            <div><b>Landmark:</b> {viewKyc?.cashfreeResponse?.split_address?.landmark}</div>
            <div><b>State:</b> {viewKyc?.cashfreeResponse?.split_address?.state}</div>
            <div><b>Pincode:</b> {viewKyc?.cashfreeResponse?.split_address?.pincode}</div>
            <div><b>Country:</b> {viewKyc?.cashfreeResponse?.split_address?.country}</div>
            <div style={{ margin: "12px 0" }}>
              <b>Aadhaar Front:</b><br />
              {viewKyc.aadhaarFrontUrl && <img src={`${process.env.REACT_APP_BASEURL}/${viewKyc.aadhaarFrontUrl}`} alt="Aadhaar Front" style={{ maxWidth: 200, borderRadius: 6, marginBottom: 8 }} />}
            </div>
            <div style={{ margin: "12px 0" }}>
              <b>Aadhaar Back:</b><br />
              {viewKyc.aadhaarBackUrl && <img src={`${process.env.REACT_APP_BASEURL}/${viewKyc.aadhaarBackUrl}`} alt="Aadhaar Back" style={{ maxWidth: 200, borderRadius: 6, marginBottom: 8 }} />}
            </div>
            <div style={{ margin: "12px 0" }}>
              <b>PAN Photo:</b><br />
              {viewKyc.panUrl && <img src={`${process.env.REACT_APP_BASEURL}/${viewKyc.panUrl}`} alt="PAN" style={{ maxWidth: 200, borderRadius: 6, marginBottom: 8 }} />}
            </div>
            <div style={{ margin: "12px 0" }}>
              <b>Signature:</b><br />
              {viewKyc.signatureUrl && <img src={`${process.env.REACT_APP_BASEURL}/${viewKyc.signatureUrl}`} alt="Signature" style={{ maxWidth: 200, borderRadius: 6, marginBottom: 8 }} />}
            </div>
            <div style={{ margin: "12px 0" }}>
              <b>Video:</b><br />
              {viewKyc.videoUrl && <video src={`${process.env.REACT_APP_BASEURL}/${viewKyc.videoUrl}`} controls style={{ maxWidth: 200, borderRadius: 6, marginBottom: 8 }} />}
            </div>
            <button onClick={() => setViewKyc(null)} style={{ position: "absolute", top: 8, right: 12, background: "transparent", border: "none", fontSize: 24, cursor: "pointer" }}>×</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default KycList;